const BASE_URL = window.env.API_BASE_URL;

export const userLogin = async (email, password) => {
  try {
    const response = await fetch(`${BASE_URL}/User/Login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      throw new Error("Invalid credentials");
    }

    const data = await response.json();

    try {
      const proxyResponse = await fetch(`${BASE_URL}/Proxy/Login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
        credentials: "include",
      });

      if (!proxyResponse.ok) {
        throw new Error("Failed to login to proxy");
      }
    } catch (error) {
      throw new Error("Failed to login to proxy");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const userRegister = async (fullName, email, password) => {
  try {
    const response = await fetch(`${BASE_URL}/User/Register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fullName, email, password }),
    });

    if (!response.ok) {
      throw new Error("Registration failed");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const refreshAuthToken = async refreshToken => {
  try {
    const response = await fetch(`${BASE_URL}/User/RefreshToken`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to refresh token");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const refreshProxyCookie = async refreshToken => {
  try {
    const response = await fetch(`${BASE_URL}/Proxy/RefreshCookie`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to refresh proxy cookie");
    }
  } catch (error) {
    throw error;
  }
};
